__turbopack_context__.v({
  "className": "caveat_ed197022-module__1rP8UG__className",
});
